import { FC } from "react";
import { SearchConditionGroupResponse } from "@/web-client";

interface SearchConditionGroupCheckboxOnSpProps {
  searchConditionGroup: SearchConditionGroupResponse;
  selectedIds: number[];
  onChange: (params: { checked: boolean; value: number }) => void;
}

export const SearchConditionGroupCheckboxOnSp: FC<
  SearchConditionGroupCheckboxOnSpProps
> = ({
  searchConditionGroup: { values },
  selectedIds,
  onChange,
}): JSX.Element => {
  return (
    <ul className="BorderList">
      {values.map((value) => (
        <li key={value.id} className="py-12">
          <label className="flex items-center gap-8">
            <input
              type="checkbox"
              value={value.id}
              checked={selectedIds.includes(value.id)}
              onChange={(e) =>
                onChange({
                  checked: e.target.checked,
                  value: Number(e.target.value),
                })
              }
            />

            <span>{value.label}</span>
          </label>
        </li>
      ))}
    </ul>
  );
};
